export default {
  STANDALONE: true,
  HOST: 'https://dev-aste-fantacalcio.com',
  HOST_FANTAPAZZ: 'https://www.devfantapazz.com',
  WEBSITE: 'dev-aste-fantacalcio.com',
  CDN_API_ENDPOINT: 'https://cdn.api.devfantapazz.com',
  API_ENDPOINT: 'https://api.devfantapazz.com', // serve per listone conf
  // API_TOKEN: ',
  PUBLIC_DIR: "https://fpz.s3-eu-west-1.amazonaws.com/files/public",
  ID_ANNO_MAGLIE: "18",
  AVATAR_OR_FLAG: "avatar",
  MAGLIA_OR_FLAG: "maglia",
  FIREBASE_HOST: 'https://dev-aste-fantacalcio.com',
  ANNO_ID: "2026-27", // deve essere sempre uguale in tutte e 4 le conf-app. Dovrei sporstarlo fuori
  TORNEO_ID: "seriea", // usato anche da paypal
  TABLE_NUM_DEFAULT: "",
  LOGIN_DEVELOPER: false,
  GOOGLE_SIGNIN_CLIENT_ID: "482712267334-vmbv3jkh9g59p2t07vot844p5ga0va90.apps.googleusercontent.com",
  GOOGLE_SIGNIN_JS_SDK: "https://accounts.google.com/gsi/client",
  APPLE_SIGNIN_JS_SDK: "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js",
  APPLE_SIGNIN_CLIENT_ID: 'com.aste-standalone-dev-signin', // service ID
  APPLE_SIGNIN_REDIRECT_URI: 'https://dev-aste-fantacalcio.com', // 'https://dev-aste-fantacalcio.com/__/auth/handler',
  FORCE_DISPLAY_NAME: true,
  CREA_ASTA: true,
  TERMINI_E_CONDIZIONI_LINK: "https://www.devfantapazz.com/termini-e-condizioni",
  PAYPAL_HOST: "www.sandbox.paypal.com",
  PREZZI: [{
      legaDa: 2,
      prezzo: 4.99,
      buttonId: "7ZRFHVDWNKC9Q",
    },
    {
      legaDa: 3,
      prezzo: 4.99,
      buttonId: "ZZ24M4HRUG3JQ",
    },
    {
      legaDa: 4,
      prezzo: 7.99,
      buttonId: "XZSLUZEQNPSZG",
    },
    {
      legaDa: 5,
      prezzo: 7.99,
      buttonId: "S3LYZEBZNJGPU",
    },
    {
      legaDa: 6,
      prezzo: 10.99,
      buttonId: "ZZJLC8783TNZQ",
    },
    {
      legaDa: 7,
      prezzo: 10.99,
      buttonId: "SJ7ACUY46ZYXU",
    },
    {
      legaDa: 8,
      prezzo: 14.99,
      buttonId: "69K27NEL75SPS",
    },
    {
      legaDa: 9,
      prezzo: 14.99,
      buttonId: "2KAJ7ESR347MG",
    },
    {
      legaDa: 10,
      prezzo: 16.99,
      buttonId: "9E2MXS4UUR254",
    },
    {
      legaDa: 11,
      prezzo: 16.99,
      buttonId: "R2HKKP8FF9WCJ",
    },
    {
      legaDa: 12,
      prezzo: 18.99,
      buttonId: "N52MW4FSJ9BJ4",
    },
    {
      legaDa: 13,
      prezzo: 18.99,
      buttonId: "3MFL3RCQ6BYVC",
    },
    {
      legaDa: 14,
      prezzo: 18.99,
      buttonId: "XK2EKHR8FH8SA",
    },
    {
      legaDa: 15,
      prezzo: 18.99,
      buttonId: "T6HW6J2WQ27RU",
    },
    {
      legaDa: 16,
      prezzo: 18.99,
      buttonId: "3BVMZWA5N4BNY",
    },
    {
      legaDa: 17,
      prezzo: 18.99,
      buttonId: "SAMHV7VQJH39N",
    },
    {
      legaDa: 18,
      prezzo: 18.99,
      buttonId: "5BZL5ZUP27XHC",
    },
    {
      legaDa: 19,
      prezzo: 18.99,
      buttonId: "HBDJ6RQU7SU9A",
    },
    {
      legaDa: 20,
      prezzo: 20.99,
      buttonId: "KELZKKERS5L2S",
    },
  ],
}
